export default {"src":"/_next/static/media/pencil-edit.4446fa0c.svg","height":512,"width":513};